// extracted by mini-css-extract-plugin
export var description = "PersonalSurvey_description__H-f0o";
export var header = "PersonalSurvey_header__wc0hd";
export var hiddenDesktop = "PersonalSurvey_hiddenDesktop__1kBSE";
export var hiddenMobile = "PersonalSurvey_hiddenMobile__jQk9w";
export var md = "768px";
export var shared = "\"../shared.module.css\"";
export var subheader = "PersonalSurvey_subheader__HWd1X";